import { Routes, Route, Navigate } from "react-router-dom";

import Header from "./Header";

import { Container } from "react-bootstrap";

const App = () => {
	return (
		<Container className="mt-3 mb-2">			
			<Routes>
				<Route path="/" element={<Header />} />
				<Route path="*" element={<Navigate to="/" />} />
			</Routes>
		</Container>
	);
};

export default App;
